import axios from 'axios';
import { BACKEND_URL } from "../config/config.js";

const axiosCustom = axios.create({
  baseURL: BACKEND_URL,
  // otras configuraciones
});

axiosCustom.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      console.log('call the refresh token api here');
      window.location.href = '/';
    }
    return Promise.reject(error);
  },
);

export default axiosCustom;
